export const version = "bignumber/5.4.2";
//# sourceMappingURL=_version.js.map